export default __webpack_public_path__ + "static/fish2-88b9fa8b1c17f5765a83d7b271a60cf3.svg";